class Ticket {
  constructor(id, category, title, content, date) {
    this.id = id;
    this.category = category;
    this.title = title;
    this.content = content;
    this.date = date;
  }
}

export default Ticket;
